"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "RowColorViewHelpers", {
    enumerable: true,
    get: function() {
        return RowColorViewHelpers;
    }
});
const _Noco = /*#__PURE__*/ _interop_require_default(require("~/Noco"));
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
let RowColorViewHelpers = class RowColorViewHelpers {
    static withContext(context, props) {
        if (!props) {
            props = {};
        }
        if (!props.ncMeta) {
            props.ncMeta = _Noco.default.ncMeta;
        }
        return new RowColorViewHelpers(context, props);
    }
    async getRowColorConditions(views) {
        return views.map((v)=>({
                view: v,
                rowColoringConditions: []
            }));
    }
    async randomizeRowColorConditionId(payload) {
        return payload;
    }
    async getDuplicateRowColorConditions(param) {
        return {
            result: param.views.map((v)=>({
                    view: v,
                    rowColoringConditions: []
                })),
            filters: [],
            rowColorConditions: []
        };
    }
    mapMetaColumn(payload) {
        return payload.meta;
    }
    async viewDeleted(_view) {}
    constructor(context, props){
        this.context = context;
        this.props = props;
    }
};
